// The Charm shelf, full view: every charm, earned or not, with how to earn it.
// Also shows the creatures she has assembled (Dino Dig).

import { h } from '@kit/dom';
import { CHARMS, drawCharm } from '../charms';
import { getSave } from '../state';
import { topBar } from '../ui';

export function charmsScreen(root: HTMLElement) {
  const s = getSave();
  const have = new Set(s.charms);
  const bar = topBar('Charm Shelf', { back: 'house' });
  const body = h('div.stack', { style: { padding: '0 16px 24px' } });
  root.append(bar, body);

  body.append(h('p.muted.small', null, `${have.size} of ${CHARMS.length} charms. Charms are earned, never bought.`));

  const grid = h('div.grid2');
  for (const c of CHARMS) {
    const got = have.has(c.id);
    const cv = document.createElement('canvas');
    const dpr = window.devicePixelRatio || 1;
    cv.width = 56 * dpr; cv.height = 56 * dpr; cv.style.width = '56px'; cv.style.height = '56px';
    const cx = cv.getContext('2d')!; cx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (got) drawCharm(cx, c, 28, 28, 20);
    else { cx.fillStyle = 'rgba(0,0,0,.08)'; cx.beginPath(); cx.arc(28, 28, 20, 0, 7); cx.fill(); cx.fillStyle = '#9a9aa3'; cx.font = '800 20px Nunito, sans-serif'; cx.textAlign = 'center'; cx.textBaseline = 'middle'; cx.fillText('?', 28, 29); }
    grid.append(h('div.card', { style: { display: 'flex', gap: '10px', alignItems: 'center', opacity: got ? '1' : '.7' } },
      cv,
      h('div', null, h('div', { style: { fontWeight: '800' } }, got ? c.name : 'Not yet'), h('div.muted.small', null, c.hint)),
    ));
  }
  body.append(grid);

  const creatures = (s.kept.creature || []) as { t: number; data: { name: string } }[];
  if (creatures.length) {
    const names = Array.from(new Set(creatures.map(c => c.data.name)));
    body.append(h('h3', { style: { marginTop: '8px' } }, 'Fossil hall'),
      h('p.muted.small', null, `Skeletons you have assembled: ${names.length}`),
      h('div.row.wrap', null, names.map(n => h('span.pill', null, n))));
  }
}
